import { Checkbox, FilterWrapper } from "components/common/elastic/style";
//import { useEsConfig } from 'context/elasticsearch/esConfigContext'
//import { useStoreContext } from 'context/StoreProvider'
import { useNestedFieldSearch } from "context/elasticsearch/nestedFields/useNestedFieldSearch";
import { appendClassName } from "utils";
import { CodeSystem } from "utils/constants/elasticsearchConfig";

type SearchFieldFilterProps = {
  className?: string;
  label: string;
};

const SearchFieldFilter = ({ className, label }: SearchFieldFilterProps) => {
  /*const { state, actions } = useStoreContext()
	const { config, batchUpdateNestedProperties } = useEsConfig(CodeSystem.Adm)*/

  const { value: searchNestedFields, updateValue: updateSearchNestedFields } =
    useNestedFieldSearch(CodeSystem.Adm, false);

  const handleNestedFieldToggle = (isEnabled: boolean) => {
    updateSearchNestedFields(isEnabled);
  };

  const handleToggle = () => {
    // Toggle all fields at once using batch update
    const newState = !searchNestedFields;
    handleNestedFieldToggle(newState);
  };

  return (
    <FilterWrapper className={appendClassName(className)}>
      <Checkbox
        type="checkbox"
        label={label}
        id={`facet-${label}`}
        name={`facet-${label}`}
        checked={searchNestedFields}
        onChange={handleToggle}
        style={{ fontWeight: searchNestedFields ? "bold" : "normal" }}
      />
    </FilterWrapper>
  );
};

export default SearchFieldFilter;
